<template>
  <div class="activation">
    <div class="title">产品真伪查询</div>

    <div class="form-wrap">
      <div class="vin-input-wrap">
        <img class="icon" :src="$IMG_BASE_URL + '/1_14.png'" />
        <div class="label">&emsp;&nbsp;&ensp;vin码:</div>
        <div class="vin-input">{{ vinCode }}</div>
      </div>
      <div class="vin-input-wrap">
        <img class="icon" :src="$IMG_BASE_URL + '/1_9.png'" />
        <div class="label">车主姓名:</div>
        <input class="vin-input" type="text" placeholder="请输入车主姓名" maxlength="16" v-model.trim="formData.carOwnerName" />
      </div>

      <div class="vin-input-wrap">
        <img class="icon" :src="$IMG_BASE_URL + '/1_10.png'" />
        <div class="label">车主电话:</div>
        <input class="vin-input" type="text" placeholder="请输入车主电话" maxlength="11"
          onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')"
          v-model="formData.carOwnerPhone" />
      </div>

      <div class="vin-input-wrap">
        <img class="icon" :src="$IMG_BASE_URL + '/1_11.png'" />
        <div class="label">产品类别:</div>
        <div class="vin-input placeholder" @click="showPicker('productTypeList')" v-if="!formData.categoryName">
          请选择产品类别
        </div>
        <div class="vin-input" @click="showPicker('productTypeList')" v-else>
          {{ formData.categoryName }}
        </div>
        <div class="select-icon"></div>
      </div>

      <div class="vin-input-wrap">
        <img class="icon" :src="$IMG_BASE_URL + '/1_12.png'" />
        <div class="label">汽车品牌:</div>
        <div class="vin-input placeholder" @click="showPicker('carBrandList')" v-if="!formData.brandName">
          请选择汽车品牌
        </div>
        <div class="vin-input" @click="showPicker('carBrandList')" v-else>
          {{ formData.brandName }}
        </div>
        <div class="select-icon"></div>
      </div>

      <div class="vin-input-wrap">
        <img class="icon" :src="$IMG_BASE_URL + '/1_13.png'" />
        <div class="label">购买日期:</div>
        <div class="vin-input placeholder" @click="showDatePicker" v-if="!selectDate">请选择购买日期</div>
        <div class="vin-input" @click="isShowDatePicker = true" v-else>
          {{ formData.buyDate }}
        </div>
        <img class="date-icon" :src="$IMG_BASE_URL + '/final/1_15.png'" />
        <div class="select-icon"></div>
      </div>

      <div class="vin-input-wrap">
        <img class="icon" :src="$IMG_BASE_URL + '/1_14.png'" />
        <div class="label">购买渠道:</div>
        <input class="vin-input" placeholder="请如实填写销售方的名称" maxlength="30" v-model="formData.buyWay" />
      </div>

      <div class="tip">
        <div class="title">注意事项</div>
        <span>感谢您选择购买{{
          $store.state.encodeInfo.zhangtao
        }}产品，为了保障您的合法消费权益，正确激活产品质保，请如实填写以上必填内容。</span>
      </div>

      <my-button form-type="submit" class="next-step-btn" @click.native="nextStep"
        :loading="isOnActivation">下一步</my-button>

      <my-button class="back-btn" type="gray" @click.native="$router.back()">返回</my-button>
    </div>

    <footer></footer>

    <van-popup v-model="isShowPicker" round position="bottom">
      <van-picker show-toolbar :columns="pickerData" @confirm="onPickerConfirm" @cancel="isShowPicker = false" />
    </van-popup>

    <van-popup v-model="isShowDatePicker" round position="bottom">
      <van-datetime-picker v-model="selectDate" type="date" title="选择年月日" @confirm="onDatePickerConfirm"
        @cancel="isShowDatePicker = false" :min-date="minDate" :max-date="maxDate" />
    </van-popup>
  </div>
</template>

<script>
import { reqGetDataList, reqActivation } from '@/network'
import { formatTime } from '@/utils/format'
export default {
  data() {
    return {
      productTypeList: [],
      carBrandList: [],
      isShowPicker: false,
      isShowDatePicker: false,
      pickerData: [],
      selectDate: new Date(),
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(),
      formData: {
        buyDate: formatTime()
      },
      vinCode: '',
      isOnActivation: false,
      currentDate: ''
    }
  },
  created() {
    this.vinCode = this.$route.query.vinCode
    this.getDataList()
  },

  methods: {
    async getDataList() {
      const {
        data: { list: productTypeList }
      } = await reqGetDataList(1)
      const {
        data: { list: carBrandList }
      } = await reqGetDataList(2)
      this.productTypeList = productTypeList.map((item) => item.categoryName)
      this.carBrandList = carBrandList.map((item) => item.brandName)
    },
    showPicker(pickerData) {
      this.pickerData = this[pickerData]
      this.isShowPicker = true
    },

    showDatePicker() {
      this.isShowDatePicker = true
      this.currentDate = new Date()
      this.selectDate = this.currentDate
    },

    onPickerConfirm(value) {
      console.log(value)
      if (this.pickerData === this.productTypeList) {
        this.formData.categoryName = value
      } else if (this.pickerData === this.carBrandList) {
        this.formData.brandName = value
      }
      this.isShowPicker = false
    },

    onDatePickerConfirm(value) {
      this.formData.buyDate = formatTime(value)
      this.isShowDatePicker = false
    },

    async nextStep() {
      console.log(this.formData)
      if (!this.formData.carOwnerName) return this.$toast('请输入车主姓名')
      if (!this.formData.carOwnerPhone) return this.$toast('请输入车主电话')
      if (!/^1[0-9]{10}$/.test(this.formData.carOwnerPhone)) return this.$toast('电话号码格式不正确')
      if (!this.formData.categoryName) return this.$toast('请选择产品类别')
      if (!this.formData.brandName) return this.$toast('请选择汽车品牌')
      if (!this.formData.buyDate) return this.$toast('请选择购买日期')
      if (!this.formData.buyWay) return this.$toast('请输入购买渠道')

      this.formData.encode = this.$store.state.encode
      this.formData.frameNumber = this.vinCode

      this.isOnActivation = true
      try {
        await reqActivation(this.formData)
        await this.$store.dispatch('getEncodeInfo')
        window.sessionStorage.setItem('firstActivation', '1')
        this.$router.push('/activation-info')
      } catch (error) { }
      this.isOnActivation = false
    }
  }
}
</script>

<style scoped lang="less">
.activation {
  padding: 20px 30px;
  text-align: center;
  font-size: 13px;

  .title {
    text-align: left;
  }

  .form-wrap {
    .vin-input-wrap {
      display: flex;
      align-items: center;
      position: relative;
      margin: 10px 5px;
      padding: 5px;
      border: 1px solid #f5f5f5;

      &:first-child {
        margin-top: 15px;
      }

      .icon {
        width: 15px;
        height: 15px;
      }

      .label {
        min-width: 56px;
        margin: 0 5px;
      }

      .vin-input {
        flex: 1;
        height: 25px;
        line-height: 25px;
        padding: 0 30px 0 10px;
        text-align: left;

        background-color: #f5f5f5;

        .content {
          .over-hidden-text();
        }
      }

      ::placeholder {
        font-size: 12px;
        color: #999;
      }

      .placeholder {
        font-size: 12px;
        color: #999;
      }

      .select-icon {
        position: absolute;
        right: 15px;
        top: 10px;
        width: 10px;
        height: 10px;
        border-right: 1px solid #999;
        border-bottom: 1px solid #999;
        transform: rotateZ(45deg);
      }

      .date-icon {
        position: absolute;
        right: 35px;
        top: 10px;
        width: 16px;
        height: 16px;
      }
    }

    .tip {
      margin: 40px 0;
      line-height: 20x;
      color: #999;

      .title {
        margin: 10px 0 5px 0;
        font-weight: bold;
        font-size: 15px;
        color: #000;
      }
    }

    .next-step-btn {
      margin-bottom: 25px;
    }
  }
}
</style>
